import { baseApi } from "./apiConfig.js";

export const getRequestId = async (data) => {
  try {
    const response = await baseApi.post("/portal/lean-regn/getUserToken", data);
    return response.data;
  } catch (error) {
    console.error("request ID error", error);
    throw error;
  }
};

export const signIn = async (data) => {
  try {
    const response = await baseApi.post("/portal/signIn", data);
    return response.data;
  } catch (error) {
    console.error("password error", error);
    throw error;
  }
};

export const internalSignOut = async () => {
  try {
    const response = await baseApi.post("/portal/logout");
    return response.data;
  } catch (error) {
    console.error("Error while Signout", error);
    throw error;
  }
};
export const checkPhoneNumberInUse = async (phoneNumber) => {
  try {
    const response = await baseApi.get(
      `/portal/isPhoneNumberInUse?phoneNumber=${phoneNumber}`
    );
    return response.data;
  } catch (error) {
    console.error("Phone number check error:", error);
    throw error;
  }
};

// Check if password is valid
export const isValidPassword = async (data) => {
  try {
    const response = await baseApi.post(
      "/portal/lean-regn/isValidPassword",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Password validation error:", error);
    throw error;
  }
};
export const getLicenseAddressRequiredStateList = async (data) => {
  try {
    const response = await baseApi.post(
      "/portal/user/getLicenseAddressRequiredStateList"
    );
    return response.data;
  } catch (error) {
    console.error("Password validation error:", error);
    throw error;
  }
};
export const getPropertyWatchStatus = async (data) => {
  try {
    const response = await baseApi.post(
      "/portal/user/getLicenseAddressRequiredStateList"
    );
    return response.data;
  } catch (error) {
    console.error("Password validation error:", error);
    throw error;
  }
};

export const registerUser = async (userData) => {
  try {
    const response = await baseApi.post(
      "/portal/lean-regn/registerUser",
      userData
    );
    return response.data;
  } catch (error) {
    console.error("Register user error:", error);
    throw error;
  }
};

// Usage in component
const checkUserVerification = async () => {
  try {
    const response = await getUserProfileVerificationDetails();
    // Handle the response data here
    // console.log("Verification details:", response);
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching verification details:", error);
  }
};

// Verify user profile
export const verifyUserProfile = async (data) => {
  try {
    const response = await baseApi.post(
      "/portal/lean-regn/verifyUserProfile",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Profile verification error:", error);
    throw error;
  }
};
export const sendVerificationCode = async (data) => {
  const payload = {
    phoneNumber: data.phoneNumber,
    verificationType: data.verificationType,
  };
  try {
    const response = await baseApi.post(
      "/portal/sendVerificationCode",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Profile verification error:", error);
    throw error;
  }
};
export const validateVerificationCode = async (data) => {
  try {
    const response = await baseApi.post(
      "/portal/validateVerificationCode",
      data
    );
    return response.data;
  } catch (error) {
    console.error("verification code error", error);
    throw error;
  }
};
export const resendVerificationCode = async (data) => {
  try {
    const response = await baseApi.post("/portal/resendVerificationCode", data);
    return response.data;
  } catch (error) {
    console.error("resend verification error", error);
    throw error;
  }
};

export const sendResetPassword = async (emailId) => {
  try {
    const response = await baseApi.post(
      "/portal/lean-regn/sendResetPasswordLink",
      { emailId }
    );
    return response.data;
  } catch (error) {
    console.error("send reset password api error", error);
    throw error;
  }
};

export const handleSocialAuth = async (user, service) => {
  try {
    const response = await baseApi.post(
      `portal/socialSignIn?service=${service}`,
      user
    );
    return response.data;
  } catch (error) {
    console.error(`${service} authentication error:`, error);
    throw error;
  }
};

export const isAppleRegisteredUser = async (payload) => {
  try {
    const response = await baseApi.post(
      `/portal/socialSignIn/isAppleRegisteredUser`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(`${service} authentication error:`, error);
    throw error;
  }
};
export const validateEmail = async (email) => {
  try {
    const response = await baseApi.post(
      "/portal/lean-regn/validateEmail",
      email
    );
    return response.data;
  } catch (error) {
    console.log("validate email api error", error);
    throw error;
  }
};
export const googleSignin = async (user) => {
  try {
    const response = await baseApi.post(`portal/socialSignInGoogleApp`, user);
    return response.data;
  } catch (error) {
    console.error("Google sign-in error:", error.response || error);
    throw error;
  }
};

//fetch loginSignup page CMS
export const getLoginSignupCMS = async (path) => {
  const response = await baseApi.get(
    encodeURI(`portal/get-new-cms-data/hubzuweb?template=/hubzuweb/${path}`)
  );
  if (response && response.status === 200) {
    return response.data;
  }
  return null;
};

export const updateUserDetails = async (data) => {
  try {
    const response = await baseApi.post(
      "/portal/lean-regn/updateUserDetails",
      data
    );
    // console.log("resend verification response ->", response.data);
    return response.data;
  } catch (error) {
    console.error("resend verification error", error);
    throw error;
  }
};

// export const getExperiments = async (experimentType, userId) => {
//   try {
//     // Validate required parameters
//     if (!experimentType) {
//       throw new Error("experimentType is required");
//     }

//     // Create URL parameters
//     const params = new URLSearchParams({
//       experimentType: experimentType,
//     });

//     // Add userId if it exists
//     if (userId) {
//       params.append("userId", userId);
//     }

//     // Make API call with constructed URL
//     const response = await baseApi.get(
//       `/portal/api/getExperiments?${params.toString()}`
//     );

//     // Validate response
//     if (!response?.data) {
//       throw new Error("Invalid response from server");
//     }

//     return response.data;
//   } catch (error) {
//     console.error("Error fetching experiment data:", {
//       message: error.message,
//       experimentType,
//       userId,
//     });
//     throw error;
//   }
// };

export const alertsSummary = async () => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(`/portal/getAlertSummary`);
    return response.data;
  } catch (error) {
    console.error("redis error", error);
    throw error;
  }
};

export const validateResetPwdToken = async (token) => {
  try {
    const response = await baseApi.get(
      `/portal/lean-regn/getResetPassword?tokenId=${token}`
    );
    return response.data;
  } catch (error) {
    console.error("redis error", error);
    throw error;
  }
};
